import React from 'react';

import SPAPill, { SPAPillTone } from '@/components/admin/SysadminSPA/shared/SPAPill';

import { Status } from './types';

const VERDICT: Record<Status, { label: string; tone: SPAPillTone }> = {
  changed: { label: 'Changed — review', tone: 'error' },
  no_change: { label: 'No change', tone: 'success' },
  no_print_match: { label: 'No print counterpart', tone: 'neutral' },
  not_compared: { label: 'Not compared — review', tone: 'warning' },
  online_missing: { label: 'Not online yet', tone: 'accent' },
};

// Below this, a "changed" verdict almost never means a genuine rewrite — it means the section
// matched the wrong print content (a stray stub, a duplicate). Flag it as a mismatch to check, so
// nobody edits against the wrong source.
const LIKELY_MISMATCH = 0.2;

const VerdictBadge = ({ ratio, status }: { ratio?: number | null; status: Status }) => {
  const mismatch = status === 'changed' && ratio != null && ratio < LIKELY_MISMATCH;
  const verdict = mismatch ? { label: 'Possible mismatch — check', tone: 'error' as const } : VERDICT[status];

  return <SPAPill tone={verdict.tone}>{verdict.label}</SPAPill>;
};

export default VerdictBadge;
